import {Geo, wgs} from "./geodesy";


export class Task {
    constructor(task) {
        this.task = task instanceof Task ? task.task : task
    }
    get waypoints () {
        return this.task.data.g
    }
    get turnpoints () {
        return this.waypoints.slice(1,-1)
    }
    get startWpt() {
        return this.waypoints[0]
    }
    get finishWpt() {
        return this.waypoints[this.waypoints.length-1]
    }
    get distance () {
        const start=this.startWpt
        const finish=this.finishWpt
        const turnpoints = this.turnpoints

        let d= 0
        let p1= wgs(start.a,start.o)
        turnpoints.forEach(tp=>{
            const p2=wgs(tp.a,tp.o)
            d+=p1.distanceTo(p2)
            p1=p2
        })
        d+=p1.distanceTo(finish.a,finish.o)
        return d
    }
    get optimumDistance () {
        const start=wgs(this.startWpt.a,this.startWpt.o)
        const finish=wgs(this.finishWpt.a,this.finishWpt.o)
        const turnpoints = this.turnpoints.map(tp=>wgs(tp.a,tp.o))
        const controlPoint = turnpoints[turnpoints.length-1]

        const optimizedPoints = []

        let p1= start

        for (let i=0 ; i<turnpoints.length-1; i++) {
            let p2=turnpoints[i]
            let p3= turnpoints[i+1]

            const azi1 = p2.azimuthTo(p1)
            const azi2 = p2.azimuthTo(p3)
            const bisector = Geo.bisector(azi1,azi2)

            optimizedPoints.push(p2.toPoint(bisector,.5))

            p1=p2
        }

        optimizedPoints.push(controlPoint)

        p1=start
        let d=start.distanceTo(optimizedPoints[0])

        for (let i=0 ; i<optimizedPoints.length-1; i++) {
            d+=optimizedPoints[i].distanceTo(optimizedPoints[i+1])
        }

        d+=controlPoint.distanceTo(finish)

        this.optimizedPoints=optimizedPoints

        return d
    }
}

export class HandicappedTask extends Task {
    constructor(task) {
        super(task)
    }

    calculateTurnpoints(handicappedIndex) {
        const start=wgs(this.startWpt.a,this.startWpt.o)
        const finish=wgs(this.finishWpt.a,this.finishWpt.o)
        const turnpoints = this.turnpoints.map(tp=>wgs(tp.a,tp.o))
        const controlPoint = turnpoints[turnpoints.length-1]

        const optimumDistance = this.optimumDistance
        const targetDistance = optimumDistance * handicappedIndex
        const targetDistanceReduction = optimumDistance - targetDistance
        const directionChangeThreshold  = 60

        const successThreshold = (optimumDistance - targetDistance)*.01

        console.log("*** Handicapped task calculation")
        console.log(`Optimum distance: ${optimumDistance.toFixed(3)} km`)
        console.log(`Target distance: ${targetDistance.toFixed(3)} km`)
        console.log(`Target distance reduction: ${(targetDistanceReduction).toFixed(3)} km`)

        const bisectors = []
        const directionChange = []

        let p1= start

        for (let i=0 ; i<turnpoints.length-1; i++) {
            let p2=turnpoints[i]
            let p3= turnpoints[i+1]

            const azi1 = p2.azimuthTo(p1)
            const azi2 = p2.azimuthTo(p3)
            const bisector = Geo.bisector(azi1,azi2)

            bisectors.push(bisector)

            directionChange.push (180 - Geo.angleDifference(azi1,azi2))

            p1=p2
        }

        let radii, tps, hasSolution, d

        for (let i=1; i<150 ; i++) {
            radii = []
            tps = []
            bisectors.forEach((bisector, idx) => {
                const r = directionChange[idx] < directionChangeThreshold ? 500 : 500 + i*100
                radii.push(r)
                const tp = turnpoints[idx].toPoint(bisector,r/1000.0)
                tps.push(tp)
            })

            d= start.distanceTo(tps[0])
            tps.forEach((tp,tidx) => {
                d+= tp.distanceTo(tidx<tps.length-1 ? tps[tidx+1] : controlPoint)
            })
            d+=controlPoint.distanceTo(finish)

            //console.log(`iteration ${i} - distance = ${d.toFixed(3)}`)

            if(d-targetDistance < 0) {
                hasSolution = true
                break
            }
        }

        if (hasSolution) {

            let solution={
                distance: d,
                solutionError: Math.abs(d-targetDistance),
                radii: [...radii],
                fixes: [...tps],
            }

            for (let i=0; i< bisectors.length; i++) {
                const bisector  = bisectors[i]
                if (directionChange[i] < directionChangeThreshold) continue;
                const r= radii[i]-100
                radii[i]=r
                const tp = turnpoints[i].toPoint(bisector,r/1000.0)
                tps[i]=tp

                d= start.distanceTo(tps[0])
                tps.forEach((tp,tidx) => {
                    d+= tp.distanceTo(tidx<tps.length-1 ? tps[tidx+1] : controlPoint)
                })
                d+=controlPoint.distanceTo(finish)

                //console.log(`reverse iteration ${i} - distance = ${d.toFixed(3)}`)

                const solutionError=Math.abs(d-targetDistance)
                if (solutionError<solution.solutionError) {
                    solution={
                        distance: d,
                        solutionError: Math.abs(d-targetDistance),
                        radii: [...radii],
                        fixes: [...tps],
                    }
                }
            }

            console.log(`Solved distance: ${solution.distance.toFixed(3)} km`)
            console.log(`Solution error ${solution.solutionError.toFixed(3)*1000} m`)
            console.log(`Error = ${(solution.solutionError/targetDistanceReduction).toFixed(4)*100}%`)
            solution.radii.forEach((r,idx)=>{
                console.log(`TP${idx+1} dc = ${directionChange[idx].toFixed(0)}°,  r = ${r} m`)
            })


            return {
                distance: solution.distance.toFixed(3),
                solutionError: solution.solutionError.toFixed(3),
                radius: solution.radii,
                fix: tps.map(tp => tp.coords),
            }
        }

    }

}

export class SgpHandicap {
    constructor(handicapSetup) {

        if (!handicapSetup) handicapSetup={
            handicaps:[],
            pilotHandicaps:{},
            handicapLabels:{},
        }

        this.handicapSetup = handicapSetup
    }

    get handicaps() {
        return this.handicapSetup.handicaps
    }

    get pilotHandicaps() {
        return this.handicapSetup.pilotHandicaps
    }

    get handicapLabels() {
        return this.handicapSetup.handicapLabels
    }

    get maxHandicap() {
        return this.handicaps ? Math.max( ...this.handicaps) : 100.0
    }

    getHandicapLabel(handicap) {
        return this.handicapLabels[handicap]
    }

    addHandicap(value,label) {
        this.handicapSetup.handicaps.push(value)
        this.handicapSetup.handicapLabels[value]=label
    }

    setPilotHandicap(pilotId, handicap) {
        this.handicapSetup.pilotHandicaps[pilotId]=handicap
    }

    normalizedHandicapForPilot(pilotId) {
        return (this.pilotHandicaps[pilotId] ?? this.maxHandicap) / this.maxHandicap
    }

}
